// extracted by mini-css-extract-plugin
module.exports =  {"preloader":"_93444fe79c--preloader--futYv","spin":"_93444fe79c--spin--boFQ3"};